import { useLocation } from 'react-router-dom';

import { BreadCrumbs } from '../Layout/Header/BreadCrumbs';

import { DashboardItems } from './DashboardItems';

import { BoxBodyContainer } from '@components/Box';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { routes } from '@config/routes';

export const DashBoard = () => {
  const location = useLocation();

  const baseBreadCrumbs = [{ link: '', to: '' }];

  const isOnDashboardPage = location.pathname === routes.HOME;

  const breadCrumbLinks = isOnDashboardPage
    ? baseBreadCrumbs
    : [...baseBreadCrumbs, { link: 'Dashboard', to: routes.HOME }];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="lg:text-sm md:text-sm text-xs text-gray-500">
            Dashboard
          </div>
          <div className="lg:flex md:flex hidden">
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div className="p-4">
          <BoxBodyContainer>
            <DashboardItems />
          </BoxBodyContainer>
        </div>
      </div>
    </>
  );
};
